import React from 'react'
import PropTypes from 'prop-types'
import { AVAILABLE_ON_SOURCE } from 'domains/scraper-product/constants'
import StatusBadge from 'components/atoms/status-badge'


const propTypes = {
  available: PropTypes.bool
}

/**
 * To give nice look on Scraper Product Available status.
 * It maps `scheduled` to certain style and pass to `StatusBadge`.
 */
const ScraperProductAvailableBadge = ({ available }) => {

  available = available ? 'yes' : 'no'

  const colorMap = {
    [AVAILABLE_ON_SOURCE.YES] : 'success',
    [AVAILABLE_ON_SOURCE.NO]  : 'danger'
  }

  const labelMap = {
    [AVAILABLE_ON_SOURCE.YES] : 'Yes',
    [AVAILABLE_ON_SOURCE.NO]  : 'No'
  }

  const color = colorMap[available] || 'default'
  const label = labelMap[available] || ''

  return <StatusBadge color={ color } label={ label } />
}

ScraperProductAvailableBadge.propTypes = propTypes

export default ScraperProductAvailableBadge
